/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseModule } from '../models/api-response-module';
import { ApiResponsePagedResultModule } from '../models/api-response-paged-result-module';
import { createModule } from '../fn/module-admin-api/create-module';
import { CreateModule$Params } from '../fn/module-admin-api/create-module';
import { deleteModule } from '../fn/module-admin-api/delete-module';
import { DeleteModule$Params } from '../fn/module-admin-api/delete-module';
import { getModuleByRef } from '../fn/module-admin-api/get-module-by-ref';
import { GetModuleByRef$Params } from '../fn/module-admin-api/get-module-by-ref';
import { searchModule } from '../fn/module-admin-api/search-module';
import { SearchModule$Params } from '../fn/module-admin-api/search-module';
import { updateModule } from '../fn/module-admin-api/update-module';
import { UpdateModule$Params } from '../fn/module-admin-api/update-module';

@Injectable({ providedIn: 'root' })
export class ModuleAdminApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getModuleByRef()` */
  static readonly GetModuleByRefPath = '/v1/api/admin-ui/module/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getModuleByRef()` instead.
   *
   * This method doesn't expect any request body.
   */
  getModuleByRef$Response(params: GetModuleByRef$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseModule>> {
    return getModuleByRef(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getModuleByRef$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getModuleByRef(params: GetModuleByRef$Params, context?: HttpContext): Observable<ApiResponseModule> {
    return this.getModuleByRef$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseModule>): ApiResponseModule => r.body)
    );
  }

  /** Path part for operation `updateModule()` */
  static readonly UpdateModulePath = '/v1/api/admin-ui/module/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateModule()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateModule$Response(params: UpdateModule$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseModule>> {
    return updateModule(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateModule$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateModule(params: UpdateModule$Params, context?: HttpContext): Observable<ApiResponseModule> {
    return this.updateModule$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseModule>): ApiResponseModule => r.body)
    );
  }

  /** Path part for operation `deleteModule()` */
  static readonly DeleteModulePath = '/v1/api/admin-ui/module/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteModule()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteModule$Response(params: DeleteModule$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteModule(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteModule$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteModule(params: DeleteModule$Params, context?: HttpContext): Observable<void> {
    return this.deleteModule$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createModule()` */
  static readonly CreateModulePath = '/v1/api/admin-ui/module';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createModule()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createModule$Response(params: CreateModule$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseModule>> {
    return createModule(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createModule$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createModule(params: CreateModule$Params, context?: HttpContext): Observable<ApiResponseModule> {
    return this.createModule$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseModule>): ApiResponseModule => r.body)
    );
  }

  /** Path part for operation `searchModule()` */
  static readonly SearchModulePath = '/v1/api/admin-ui/module/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchModule()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchModule$Response(params: SearchModule$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultModule>> {
    return searchModule(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchModule$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchModule(params: SearchModule$Params, context?: HttpContext): Observable<ApiResponsePagedResultModule> {
    return this.searchModule$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultModule>): ApiResponsePagedResultModule => r.body)
    );
  }

}
